export default __webpack_public_path__ + "static/media/safe.509113bf.png";